export const PRIVATE_FEED_START = 'PRIVATE_FEED_START';
export const PRIVATE_FEED_STOP = 'PRIVATE_FEED_STOP';
export const PRIVATE_FEED_OPEN = 'PRIVATE_FEED_OPEN';
export const PRIVATE_FEED_CLOSE = 'PRIVATE_FEED_CLOSE';
export const PRIVATE_FEED_MESSAGE = 'PRIVATE_FEED_MESSAGE';
export const PRIVATE_FEED_CONNECT_REQUESTED = 'PRIVATE_FEED_CONNECT_REQUESTED';
export const PRIVATE_FEED_DISCONNECT_REQUESTED = 'PRIVATE_FEED_DISCONNECT_REQUESTED';
